import ProjectBids from './ProjectBids';

export default ProjectBids;


